import React from 'react';
import { Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
const ClaimGroupEditNavigation = _ref => {
  let {
    page,
    claimGroup
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(state => state.auth.user);
  return /*#__PURE__*/React.createElement(Nav, {
    variant: "tabs"
  }, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'general',
    to: "/".concat(user.account_type, "/claim_groups/").concat(claimGroup.id, "/edit/general")
  }, t('general'))));
};
export default ClaimGroupEditNavigation;